import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { usePrevious } from 'lib/core/hooks'
import { getCartId } from 'lib/core/data/quote/cartId/selectors'
import { getCouponApply } from 'lib/core/data/quote/couponApply/selectors'
import { getCouponRemove } from 'lib/core/data/quote/couponRemove/selectors'

interface CouponOptions {
  onApplySuccess?: () => void
  onApplyFailure?: () => void
}

export const useCoupon = (coupon: string, options?: CouponOptions) => {
  const cartId = useSelector(getCartId)
  const {
    isFetching: isApplyCouponFetching,
    isSuccess: isApplyCouponSuccess,
    isFailure: isApplyCouponFailure
  } = useSelector(getCouponApply(coupon))

  const {
    isFetching: isRemoveCouponFetching
  } = useSelector(getCouponRemove(cartId))

  const prevIsApplyCouponFetching = usePrevious(isApplyCouponFetching)

  useEffect(() => {
    const isFetchingChanged = !!prevIsApplyCouponFetching && !isApplyCouponFetching

    if (isFetchingChanged && isApplyCouponSuccess) {
      options?.onApplySuccess && options.onApplySuccess()
    }

    if (isFetchingChanged && isApplyCouponFailure) {
      options?.onApplyFailure && options.onApplyFailure()
    }

    // eslint-disable-next-line
  }, [
    isApplyCouponFetching,
    isApplyCouponSuccess,
    isApplyCouponFailure,
    prevIsApplyCouponFetching
  ])

  return {
    isApplyCouponFetching,
    isApplyCouponSuccess,
    isApplyCouponFailure,
    isRemoveCouponFetching
  }
}
